import { reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import { CommonActions } from '@react-navigation/native';
import I18n from '../../../lib/i18n';
import { wrapComponentWith } from '../../../lib/hoc';
import BillingAddress from './BillingAddress.container';
import { GradientPage } from '../../../components/common';
import { billingAddressSelector, customerFullNameSelector } from '../../../modules/Customer/selectors';
import config from '../../../config';
import Navigation from '../../../lib/navigation';
import { goToNextActivationPage } from '../../../modules/SignUp/actions';
import validate from './validation';
import { updateBillingAddressDuringProcess } from '../../../modules/BillingAddress';

const getInitialValues = state => {
  const initialValues = billingAddressSelector(state);
  if (config.askPersonalInformationDuringOrderSim) {
    return {
      ...initialValues,
      fullName: customerFullNameSelector(state),
    };
  }

  return initialValues;
};

const mapStateToProps = state => ({
  initialValues: getInitialValues(state),
  postCode: formValueSelector('billingAddress')(state, 'postCode'),
});

const mapDispatchToProps = dispatch => ({
  changeFormField: (fieldName: string, fieldValue: string) => dispatch(change('billingAddress', fieldName, fieldValue)),
  onSubmit: values => {
    dispatch(updateBillingAddressDuringProcess(values));
    if (config.askPersonalInformationDuringOrderSim) {
      dispatch(goToNextActivationPage());
    } else {
      Navigation.dispatch(CommonActions.navigate({ name: 'selfieCheck' }));
    }
  },
});

const withFlaggedProps = (): { title: string, displayCheckboxUseSameAddresses: boolean } => ({
  title: I18n.t('SignUp.BillingAddress.title'),
  displayCheckboxUseSameAddresses: false,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withFlaggedProps),
  reduxForm({ form: 'billingAddress', validate }),
  wrapComponentWith(GradientPage)
);
export default enhance(BillingAddress);
